import UpperTab from '@/core/components/UpperTab/UpperTab';

export default UpperTab;
